import Actions_status_update from 'pages/auth/actions/actions_statusupdate_forms/config.js'

export default {
    actions_status_update: Actions_status_update
}